class PageListCtrl {
  constructor(
    ConfirmService,
    StatusService,
    NewsfeedCollection,
    Utils,
    $scope,
    $uibModal,
    $state,
    $transitions
  ) {
    'ngInject';

    Object.assign(this, {
      ConfirmService,
      StatusService,
      NewsfeedCollection,
      Utils,
      $scope,
      $uibModal,
      $state,
      $transitions,
    });
  }

  membersPanelOpened = false;

  $onInit() {
    if (this.newsfeedNotifications.length) {
      this.StatusService.markNewsfeedNotificationsAsSeen(this.newsfeedNotifications[0].id);
    }

    this.$scope.$on(
      '$destroy',
      this.$transitions.onSuccess({}, (transition) => {
        const params = transition.targetState().params();
        this._createPagesForMenu(params);
      })
    );

    this._createPagesForMenu(this.$transition$?.params());
  }

  get subscribedPages() {
    return this.NewsfeedCollection.subscribedPages;
  }

  get unsubscribedPages() {
    return this.NewsfeedCollection.unsubscribedPages;
  }

  get allPages() {
    return this.NewsfeedCollection.pages;
  }

  get isEmptyNewsfeed() {
    return this.NewsfeedCollection.isEmptyNewsfeed;
  }

  get isSearchingPages() {
    return !!this.NewsfeedCollection.searchQuery;
  }

  get newsfeedNotifications() {
    return this.NewsfeedCollection.notifications;
  }

  unsubscribePage(page) {
    this.NewsfeedCollection.unsubscribe(page);
  }

  subscribePage(page) {
    this.NewsfeedCollection.subscribe(page);
  }

  deletePage(page) {
    this.ConfirmService.ask('Are you sure you want to delete this page?', async () => {
      await page.remove();
      this.$state.go('newsfeed.view.mynewsfeed');
    }).ignoreCancel();
  }

  createPage() {
    this.$state.go('newsfeed.management.createPage');
  }

  editPage(page) {
    this.$state.go('newsfeed.management.editPage', { pageId: page.id });
  }

  viewPage(page) {
    if (page && page.id) {
      this.$state.go('newsfeed.view.page', { pageId: page.id });
    } else {
      this.$state.go('newsfeed.view.mynewsfeed');
    }
  }

  membersToggle = () => {
    this.membersPanelOpened = !this.membersPanelOpened;
  };

  onQueryUpdate = (query) => {
    this.NewsfeedCollection.searchPages(query);
  };

  _createPagesForMenu(params) {
    if (params) {
      this.activePageId = params.pageId ? this.Utils.getId(params.pageId) : 0;
      this.activePage = this.activePageId
        ? this.NewsfeedCollection.allChannels.find((p) => p.id === this.activePageId)
        : undefined;
    }
  }
}

export default PageListCtrl;
